import * as Yup from 'yup';

const capitalContributionSimulationSchema = Yup.object().shape({
  amount: Yup.number()
    .typeError('SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO')
    .moreThan(0, 'SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO')
    .required('SCHEMA_ERRORS.REQUIRED_FIELD')
});

export default capitalContributionSimulationSchema;

